import type { FC } from 'react';
import { useCallback } from 'react';

import { useConfigSlice } from '../../../../store/slices/config/selectors';
import { useSettingsSlice } from '../../../../store/slices/settings/selectors';
import { toggleFullscreen } from '../../../gameRoot/useFullscreen';
import { useLegacyContext } from '../../../legacyMode/LegacyContextProvider';

import { FullScreenControlPlain } from './FullScreenControlPlain';

// Very Old Browsers and new iPads
interface WebkitDocument extends Document {
  webkitFullscreenEnabled?: boolean;
}

const fullscreenAvailable = document.fullscreenEnabled || (document as WebkitDocument).webkitFullscreenEnabled;
export const FullScreenControlConnected: FC = () => {
  const isInFullscreen = useSettingsSlice.getIsInFullscreen();
  const isFullscreenButtonHidden = !fullscreenAvailable || useConfigSlice.casinoConfig()?.hideFullScreenBtn;
  const { isLegacyMode } = useLegacyContext();

  const clickHandler = useCallback(() => {
    toggleFullscreen(isLegacyMode);
  }, [isLegacyMode]);

  return !isFullscreenButtonHidden && <FullScreenControlPlain condition={isInFullscreen} onClick={clickHandler} />;
};
